export default "__VITE_ASSET__DILrtOYM__"